<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar title="扫码点餐" left-text="返回" @click-left="onClickLeft" left-arrow fixed />
    <!--导航栏 end-->
    <!--内容 start-->
    <div style="margin-top: 1.5rem">
      <van-cell title="菜品分类" is-link @click="food_class" />
      <van-cell title="菜品" is-link @click="food" />
      <van-cell v-if="is_seat" title="桌号" is-link @click="seat" />
      <van-cell title="菜品统计" is-link @click="foodStatic" />
      <van-cell title="充值配置" is-link @click="recharge" />
      <van-cell title="充值记录" is-link @click="rechargereRecord" />
    </div>
    <!--内容 end-->
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  name: "CodeOrder", //扫码点餐
  data() {
    return {
      is_seat: 0,
    };
  },
  created() {
    this.isOpenOrder();
  },
  methods: {
    // 左侧返回
    onClickLeft() {
      this.$router.push("/StoreHomepage");
    },
    // 菜品分类
    food_class() {
      // 跳转至菜品分类
      this.$router.push("/FoodClassList");
    },
    // 菜品
    food() {
      // 跳转至菜品
      this.$router.push("/FoodList");
    },
    seat() {
      // 跳转至菜品
      this.$router.push("/SeatList");
    },
    foodStatic() {
      // 跳转菜品统计
      this.$router.push("/FoodsStatistic");
    },
    recharge() {
      // 充值配置
      this.$router.push("/recharge");
    },
    rechargereRecord() {
      // 充值记录
      this.$router.push("/rechargereRecord");
    },
    isOpenOrder() {
      this.$http
        .get("/wechat/api.merchant_info/get_store_info", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
            store_id: window.sessionStorage.getItem("store_id"),
          },
        })
        .then((response) => {
          this.is_seat = response.data.data.is_seat;
        });
    },
  },
};
</script>

<style>
</style>
